import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
//API 
import { CouponPosFetchAPI } from '../../../api/Coupon';
//utils
import HoursList from '../../utils/HoursList';
//Alerts 
import AlertError from '../../Alerts/ErrorAlert';

//Modal asing Hours cupon
const ModalAsingHoursCupon = ({ showModal, setShowModal, selectedCupon, setEventHandler }) => {
    //Function of hours
    const hours = HoursList();

    //Function to add a condition to the cupon
    const addCondtionToCupon = async (e) => {
        e.preventDefault();
        const hour = e.target.hour.value;
        try {
            let res = await CouponPosFetchAPI.addConditionCupon(selectedCupon, "TIME", hour, localStorage.getItem('x-access-token'));

            if (res.status === 200) {
                AlertError('Hora asignado correctamente al cupon', 'Exito', 'success')
                setEventHandler(1)
            }
        } catch (err) {
            console.log(err)
            AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al asignar la hora al cupon', 'error', 'error')
        }

    }
    return (
        <div>
            <Modal
                show={showModal}
                centered
                onHide={() => setShowModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Asignar hora a cupón</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={addCondtionToCupon}>
                        <Form.Group controlId="hour">
                            <Form.Label>Hora</Form.Label>
                            <Form.Select>
                                <option value={null}>Seleccione hora...</option>
                                {hours.map((day) => (
                                    <option key={"day" + day.value} value={day.value}>{day.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>Cerrar</Button>
                            <Button variant="success" type='submit'>Guardar</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>


            </Modal>
        </div>
    );
}

export default ModalAsingHoursCupon;
